<template>
  <div className="home">
    <PostList :posts="posts"/>
    <!-- Add a button or link for creating a new post -->
    <!-- Handle the click event to route to a new post creation component -->
    <NewPostPopup></NewPostPopup>
  </div>
</template>

<script>
import PostList from '../components/PostList.vue';
// Import Firebase services
import {getDatabase, ref, onValue} from 'firebase/database';
import NewPostPopup from "@/components/NewPostPopup";

export default {
  components: {
    NewPostPopup,
    PostList
  },
  data() {
    return {
      posts: []
    }
  },
  methods: {
    fetchPosts() {
      const dbRef = ref(getDatabase(), "posts");
      onValue(dbRef, (snapshot) => {
        const postsArray = [];
        snapshot.forEach((childSnapshot) => {
          const post = childSnapshot.val();
          post.id = childSnapshot.key;
          postsArray.push(post);
        });
        this.posts = postsArray.reverse();
      });
    }
  },
  created() {
    this.fetchPosts();
  }
}
</script>

<style scoped>
.home {
  margin: 20px auto;
  width: 600px;
}
/* Your CSS here */
</style>
